import { render, staticRenderFns } from "./VehicleEstimateMetodica.vue?vue&type=template&id=3b48a514&"
import script from "./VehicleEstimateMetodica.vue?vue&type=script&lang=js&"
export * from "./VehicleEstimateMetodica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports